<div class="not-found bg-primary">
  <div class="text-wrapper text-center">
    <h1 class="text-white">404 Not Found</h1>
  </div>
</div>